import React, {useContext, useState} from 'react';
import './TableEdit.less';
import {Input} from 'elements/input/Input';
import {Button} from "elements/button/Button";
import {DrawerPopup} from "dialog-layout/drawer-popup/DrawerPopup.tsx";
import {Error} from 'elements/error/Error';
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";

export const TABLE_EDIT_POPUP = 'TABLE_EDIT_POPUP';

export const TableEdit = (
	{
		defaultValue = '',
		restaurantDeliveryLabel,
		error,
		onOverlayClick,
		onCancelClick,
		onDoneClick
	}
) => {
	const [table, setTable] = useState(defaultValue);

	const translations = useContext(TranslationsContext);

	return <DrawerPopup
		title={getSafeTranslation('TableEditPopup.title.' + restaurantDeliveryLabel, translations)}
		onOverlayClick={onOverlayClick}
		leftControl={<Button isText onClick={onCancelClick}>{
			getSafeTranslation('TableEditPopup.cancelButtonCaption', translations)
		}</Button>}
		rightControl={<Button
			isAutoWidth
			onClick={() => onDoneClick(table)}
			isDisabled={!(table && table.length > 0)}>{
			getSafeTranslation('TableEditPopup.doneButtonCaption', translations)
		}</Button>}
	>
		<div className="table-edit">
			<div className="table-edit__input">
				<Input value={table} inputMode="numeric" onChange={setTable} regex={/^\d*$/} focusOnMount/>
			</div>
			{
				error && (
					<div className="table-edit__error">
						<Error text={error}/>
					</div>
				)
			}
		</div>
	</DrawerPopup>
}
